<template>
  <TradingAccountDataTable></TradingAccountDataTable>
</template>

<script>
import TradingAccountDataTable from "./TradingAccountDataTable.vue";

export default {
  components: { TradingAccountDataTable },
}
</script>